import React from 'react';
import { Box } from '@mui/material';

import Docx from '../Assets/MsDocLogo/Docx.png';
import Xlsx from '../Assets/MsDocLogo/Xlsx.png';

import PdfRender from './PdfRender';

function FileViewerCustom(props) {

    let file_url = props.fileurl;
    let file_exttype = props.exttype;

    let file_tag = "";
    if (file_exttype === 'jpg' || file_exttype === 'jpeg' || file_exttype === 'png') {
        file_tag = 'img_tag';
    } else if (file_exttype === 'pdf') {
        file_tag = 'iframe_tag';
    } else if (file_exttype === 'doc' || file_exttype === 'docx') {
        file_tag = 'doc_icon';
    } else if (file_exttype === 'xls' || file_exttype === 'xlsx') {
        file_tag = 'excel_icon';
    }


    return (
        <Box>
            {file_url && <Box  >
                {file_tag === "iframe_tag" && <PdfRender fileurl={file_url} width={props.width} height={props.height} canvasheight={props.canvasheight} canvaswidth={props.canvaswidth} />}
                {file_tag === "img_tag" && <Box  > <img src={file_url} alt="File Preview" width={props.width} height={props.height} style={{ backgroundColor: (props.color) ? props.color : 'unset' }} /> </Box>}
                {file_tag === "doc_icon" && <Box  > <img src={Docx} alt="Document file" width={props.width} height={props.height} style={{ backgroundColor: (props.color) ? props.color : 'unset' }} /> </Box>}
                {file_tag === "excel_icon" && <Box  > <img src={Xlsx} alt="Excel file" width={props.width} height={props.height} style={{ backgroundColor: (props.color) ? props.color : 'unset' }} /> </Box>}
                {file_tag === "" && <Box  > <img src="" alt="File Preview Not Available" style={{ backgroundColor: (props.color) ? props.color : 'unset' }} /> </Box>}

            </Box>
            }



        </Box>
    )
}

export default FileViewerCustom